import React from "react";
import { Tags } from "../tags";

export function MultipleTags({
  containerClass = "",
  options = [],
  Template = Tags
}) {
  return (
    <div className={containerClass}>
      {options.map(value => {
        return Template ? <Template {...value} /> : null;
      })}
    </div>
  );
}
